import fs from "node:fs/promises";
import path from "node:path";

import env from "./env";
import { CreateAbacusProfilesJob } from "./jobs/create_abacus_profiles";
import { SAPSyncContractsJob } from "./jobs/sap_sync_contracts/sapSyncContractsJob";
import { TerminateContractsJob } from "./jobs/terminate_contracts/terminateContractsJob";
import { readJSONFile } from "./utils/utils";
import { RunnerCtor, JobName, JobRequest } from "./types";
import { jobRequestSchema } from "./schemas";

const jobRegistry: Record<JobName, RunnerCtor> = {
  [JobName.CreateAbacusProfiles]: CreateAbacusProfilesJob,
  [JobName.SapSyncContracts]: SAPSyncContractsJob,
  [JobName.TerminateContracts]: TerminateContractsJob,
};

main();

async function main(): Promise<void> {
  console.log(`[${env.APPLICATION_NAME}]`);
  console.log(`Environment: ${env.ENVIRONMENT}`);

  console.log(`Reading from input file: ${env.INPUT_PATH}`);
  const inputJSON = await readJSONFile<JobRequest>(env.INPUT_PATH!);
  const jobRequest = jobRequestSchema.parse(inputJSON);

  console.log(`Running job: ${jobRequest.job}...`);
  const job = new jobRegistry[jobRequest.job]({
    logger: console,
    ...env,
    ...jobRequest.config,
  });
  const result = await job.run(jobRequest.data);

  console.log(`Writing to output file: ${env.OUTPUT_PATH}`);
  const outputJSON = JSON.stringify(result, null, 2);
  await fs.writeFile(path.resolve(env.OUTPUT_PATH), outputJSON, "utf-8");

  console.log("DONE");
}
